<template>
  <div class="bp-card seeding">
    <div class="head">
      <div class="title">
        <img class="plat-icon" :src="icon" :alt="platform" />
        <span class="dot"></span>
        <span class="t">种草码</span>
      </div>
      <div class="status">
        <div class="status-item">
          <span class="label">可发布(条)</span>
          <span class="num normal">{{ fmt(data.publishable) }}</span>
        </div>
        <div class="status-item">
          <span class="label">已发布(条)</span>
          <span class="num red">{{ fmt(data.published) }}</span>
        </div>
        <div class="status-item">
          <span class="label">待发布(条)</span>
          <span class="num grey">{{ fmt(data.pending) }}</span>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <trend-chart
      :chart-type="chartType"
      :months="data.months || []"
      :series="{ exposure: data.exposure, views: data.views, interaction: data.interaction }"
    />
  </div>
</template>

<script>
import TrendChart from './TrendChart'
import { fmtNum } from '../format'

export default {
  name: 'BpSeedingCode',
  components: { TrendChart },
  props: {
    // 平台名（小红书/抖音）
    platform: { type: String, default: '' },
    // 平台 icon 资源路径
    icon: { type: String, default: '' },
    // 'line'（小红书）| 'bar'（抖音）
    chartType: { type: String, default: 'line' },
    // 种草码数据结构见 api.js mapSeeding（publishable/published/pending + months/exposure/views/interaction）
    data: { type: Object, required: true }
  },
  methods: {
    fmt: fmtNum
  }
}
</script>

<style lang="less" scoped>
@import '../styles.less';
.seeding {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding-right: 20px;
    .title {
      display: flex;
      align-items: center;
      .plat-icon {
        width: 24px;
        height: 24px;
        border-radius: 4px;
      }
      .dot {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #D9D9D9;
        margin: 0 5px;
      }
      .t {
        font-family: @font-cn;
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        color: @bp-title;
      }
    }
    .status {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .status-item {
        display: flex;
        flex-direction: column;
        margin-left: 40px;
        .label {
          font-family: @font-cn;
          font-size: 16px;
          color: @bp-label;
          line-height: 1;
          white-space: nowrap;
        }
        .num {
          margin-top: 6px;
          font-family: @font-num;
          font-weight: 700;
          font-size: 24px;
          line-height: 1;
          &.normal { color: @bp-num; }
          &.red { color: @bp-red; }
          &.grey { color: @bp-grey-blue; }
        }
      }
    }
  }
  .divider {
    height: 1px;
    background: @bp-axis;
    opacity: 0.5;
    margin: 20px 0;
  }
}
</style>
